import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, NgForm } from '@angular/forms';
import {
  RequestAccessContentService,
  CommonContentService,
  AgencyRequestContentService
} from '@tmhcc-ng-lib/content-service';
import { CoreInputValidationService } from '@tmhcc-ng-lib/framwork/core-inputs';
import { InputConfig } from '@tmhcc-ng-lib/framwork/form-inputs';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import { Subscription } from 'rxjs';
import { AgencyConfigInfo } from './agency-request-field-config';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { getBaseUri } from '@tmhcc/util';
import { Renderer2, ViewChild, ElementRef } from '@angular/core';
declare var $: any;

@Component({
  selector: 'ae-agency-request',
  templateUrl: './agency-request.component.html',
  styleUrls: ['./agency-request.component.scss']
})
export class AgencyRequestComponent extends AgencyConfigInfo
  implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('agency_name1') agencyNameElement: ElementRef;
  @ViewChild('state1') statesElement: ElementRef;
  buttonLabel: string;
  agencyRequestReturnUrl: string;
  valueSub = new Subscription();
  frmGroup: FormGroup;
  agencyRequestField: InputConfig[];
  phoneRequestField: InputConfig[];
  emailRequestField: InputConfig[];
  agencyRequestProduct: InputConfig[];
  premiumProduct: InputConfig[];
  companyRequestField: InputConfig[];
  agencyFormControl: Object = {};
  pageTitle: string;
  pageDescription: string;
  formLabel;
  checkboxFlag: boolean = false;
  hasFormBeenSubmitted: boolean = false;
  radioSelected: boolean = false;
  oid;
  agencyRequestUrl;
  lead_source;
  debug;
  debugEmail;
  upn;
  aor;
  kraft_lake_entity_type;
  agency_status;
  first_name;
  last_name;
  agency_name;
  tax_id;
  tax_id_type;
  sub_company;
  kraft_lake_agency_type;
  commission_option;
  payment_plan;
  commission_plan;
  commission_amount;
  kraft_lake_eo_carrier;
  eo_limits;
  eo_policy_number;
  eo_expiration_date;
  address_type;
  office_address;
  city;
  state;
  zip;
  office_country;
  phone_type;
  phone;
  email_type;
  email;
  licensee_name;
  ParentLicenseType;
  LicenseNumber;
  license_expiration_date;
  tabLabel;
  requestFormLabel = {
    agencyRequestLabel: '',
    companyRequestLabel: '',
    premiumProductLabel: ''
  };
  private unlistenerFirstName: () => void;
  private unlistenerLastName: () => void;
  private unlistenerStates: () => void;

  constructor(
    private formBuilder: FormBuilder,
    private validationService: CoreInputValidationService,
    private loaderService: LoaderService,
    private SiteCoreData: AgencyRequestContentService,
    private configService: AppConfigService,
    private commonContentService: CommonContentService,
    private renderer2: Renderer2
  ) {
    super();
  }

  ngAfterViewInit(): void {
    this.setFirstNameLastNameEventHandler(
      this.agencyRequestField,
      this.agencyNameElement
    );
    //this.statesElement.nativeElement = document.getElementById("state1");
    //this.renderer2.setProperty(this.statesElement.nativeElement, 'innerHTML', document.getElementById("state1"));
    this.setStatesEventHandler(this.agencyRequestField, this.statesElement);
  }

  ngOnDestroy(): void {
    this.unlistenerFirstName();
    this.unlistenerLastName();
    this.unlistenerStates();
  }
  ngOnInit(): void {
    this.commonContentService.setPageTitle();
    this.agencyRequestReturnUrl = getBaseUri() + '/farmers-thank-you';
    this.setEntity();
    this.loaderService.show();
    this.setFormControl(
      this.agencyRequestField
      // this.phoneRequestField,
      // this.emailRequestField,
      // this.agencyRequestProduct,
      // this.premiumProduct,
      // this.companyRequestField
    );
    this.loaderService.show();
    this.requestAccessSiteCoreData();
    this.loaderService.show();
    // this.frmGroup.controls['00N6g00000TXa9h'].valueChanges.subscribe(data => {
    //   this.radioSelected = data != '' ? true : false;
    // });
  }
  requestAccessSiteCoreData() {
    this.SiteCoreData.data$.subscribe(res => {
      if (res) {        
        this.buttonLabel = res.buttons[0]?.keyText;
        this.setCnValue(res);
        // this.tabLabel = res.tabLabels[0].displayItems;
        // this.requestFormLabel.agencyRequestLabel =
        //   res.tabLabels[0].displayItems[0].description;
        // this.requestFormLabel.companyRequestLabel =
        //   res.tabLabels[0].displayItems[1].description;
        // this.requestFormLabel.premiumProductLabel =
        //   res.tabLabels[0].displayItems[2].description;

        this.oid = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.oid
        );
        this.agencyRequestUrl = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.retURL
        );
        this.lead_source = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.lead_source
        );
        this.debug = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.debug
        );
        this.debugEmail = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.debugEmail
        );
        // this.upn = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.upn
        // );
        this.aor = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.aor
        );
        // this.kraft_lake_entity_type = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.kraft_lake_entity_type
        // );
        // this.agency_status = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.agency_status
        // );
        this.first_name = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.first_name
        );
        this.last_name = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.last_name
        );
        this.agency_name = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.agency_name
        );
        // this.tax_id = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.tax_id
        // );
        // this.tax_id_type = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.tax_id_type
        // );
        // this.sub_company = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.sub_company
        // );
        // this.kraft_lake_agency_type = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.kraft_lake_agency_type
        // );
        // this.commission_option = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.commission_option
        // );
        // this.payment_plan = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.payment_plan
        // );
        // this.commission_plan = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.commission_plan
        // );
        // this.commission_amount = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.commission_amount
        // );
        // this.kraft_lake_eo_carrier = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.kraft_lake_eo_carrier
        // );
        // this.eo_limits = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.eo_limits
        // );
        // this.eo_policy_number = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.eo_policy_number
        // );
        // this.eo_expiration_date = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.eo_expiration_date
        // );
        // this.address_type = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.address_type
        // );
        this.office_address = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.office_address
        );
        this.city = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.city
        );
        this.state = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.state
        );
        this.zip = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.zip
        );
        // this.office_country = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.office_country
        // );
        // this.phone_type = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.phone_type
        // );
        this.phone = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.phone
        );
        // this.email_type = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.email_type
        // );
        this.email = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.email
        );
        // this.licensee_name = res.forms[1].fields.find(
        //   items => items.fieldInfo.fieldName == this.cn.licensee_name
        // );
        this.ParentLicenseType = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.ParentLicenseType
        );
        this.LicenseNumber = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.LicenseNumber
        );
        this.license_expiration_date = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.license_expiration_date
        );
        this.loaderService.hide();
        this.pageTitle = res.data[0].heading;
        this.pageDescription = res.data[0].description;

        this.setValidationforForm(
          res,
          //this.phoneRequestField
          // this.emailRequestField,
          this.agencyRequestField
          // this.agencyRequestProduct,
          // this.premiumProduct
        );
        this.agencyRequestField.forEach(field => {
          if (field.fieldInfo.fieldName === 'state1') {
            field.config.selectConfig.options = res.states;
          }
        });
        let parentLicenceTypeArray = [];
        res.dropdown[0].displayItems.forEach(item => {
          parentLicenceTypeArray.push({
            key: item.keyText,
            value: item.description
          });
        });
        this.agencyRequestField.forEach(field => {
          if (field.fieldInfo.fieldName === 'ParentLicenseType1') {
            field.config.selectConfig.options = parentLicenceTypeArray;
          }
        });
        let LicenseNumberArray = [];
        res.dropdown[1].displayItems.forEach(item => {
          LicenseNumberArray.push({
            key: item.keyText,
            value: item.description
          });
        });
        this.agencyRequestField.forEach(field => {
          if (field.fieldInfo.fieldName === 'LicenseNumber1') {
            field.config.selectConfig.options = LicenseNumberArray;
          }
        });
      }
    });
  }
  setCnValue(data) {
    this.cn.oid = data.forms[1].fields[0]?.fieldInfo.fieldName;
    this.cn.retURL = data.forms[1].fields[1]?.fieldInfo.fieldName;
    this.cn.lead_source = data.forms[1].fields[2]?.fieldInfo.fieldName;
    this.cn.debug = data.forms[1].fields[3]?.fieldInfo.fieldName;
    this.cn.debugEmail = data.forms[1].fields[4]?.fieldInfo.fieldName;
    // this.cn.upn = data.forms[1].fields[5]?.fieldInfo.fieldName;
    this.cn.aor = data.forms[1].fields[6]?.fieldInfo.fieldName;
    // this.cn.kraft_lake_entity_type =
    //   data.forms[1].fields[7]?.fieldInfo.fieldName;
    // this.cn.agency_status = data.forms[1].fields[8]?.fieldInfo.fieldName;
    this.cn.first_name = data.forms[1].fields[36]?.fieldInfo.fieldName;
    this.cn.last_name = data.forms[1].fields[37]?.fieldInfo.fieldName;
    this.cn.agency_name = data.forms[1].fields[9]?.fieldInfo.fieldName;
    // this.cn.tax_id = data.forms[1].fields[10]?.fieldInfo.fieldName;
    // this.cn.tax_id_type = data.forms[1].fields[11]?.fieldInfo.fieldName;
    // this.cn.sub_company = data.forms[1].fields[12]?.fieldInfo.fieldName;
    // this.cn.kraft_lake_agency_type =
    //   data.forms[1].fields[13]?.fieldInfo.fieldName;
    // this.cn.commission_option = data.forms[1].fields[14]?.fieldInfo.fieldName;
    // this.cn.payment_plan = data.forms[1].fields[15]?.fieldInfo.fieldName;
    // this.cn.commission_plan = data.forms[1].fields[16]?.fieldInfo.fieldName;
    // this.cn.commission_amount = data.forms[1].fields[17]?.fieldInfo.fieldName;
    // this.cn.kraft_lake_eo_carrier =
    //   data.forms[1].fields[18]?.fieldInfo.fieldName;
    // this.cn.eo_limits = data.forms[1].fields[19]?.fieldInfo.fieldName;
    // this.cn.eo_policy_number = data.forms[1].fields[20]?.fieldInfo.fieldName;
    // this.cn.eo_expiration_date = data.forms[1].fields[21]?.fieldInfo.fieldName;
    // this.cn.address_type = data.forms[1].fields[22]?.fieldInfo.fieldName;
    this.cn.office_address = data.forms[1].fields[23]?.fieldInfo.fieldName;
    this.cn.city = data.forms[1].fields[24]?.fieldInfo.fieldName;
    this.cn.state = data.forms[1].fields[25]?.fieldInfo.fieldName;
    this.cn.zip = data.forms[1].fields[26]?.fieldInfo.fieldName;
    // this.cn.office_country = data.forms[1].fields[27]?.fieldInfo.fieldName;
    // this.cn.phone_type = data.forms[1].fields[28]?.fieldInfo.fieldName;
    this.cn.phone = data.forms[1].fields[29]?.fieldInfo.fieldName;
    // this.cn.email_type = data.forms[1].fields[30]?.fieldInfo.fieldName;
    this.cn.email = data.forms[1].fields[31]?.fieldInfo.fieldName;
    // this.cn.licensee_name = data.forms[1].fields[32]?.fieldInfo.fieldName;
    this.cn.ParentLicenseType = data.forms[1].fields[33]?.fieldInfo.fieldName;
    this.cn.LicenseNumber = data.forms[1].fields[34]?.fieldInfo.fieldName;
    this.cn.license_expiration_date =
      data.forms[1].fields[35]?.fieldInfo.fieldName;
  }
  setFirstNameLastNameEventHandler(agencyRequestField, agencyNameElement) {
    let firstNameElement = document.getElementById('first_name1');
    let lastNameElement = document.getElementById('last_name1');
    // @ViewChild("agency_name1") agencyNameElement: ElementRef;
    agencyRequestField.forEach(field => {
      if (field.fieldInfo.fieldName === 'first_name1') {
        this.unlistenerFirstName = this.renderer2.listen(
          firstNameElement,
          'focusout',
          event => {
            agencyNameElement = document.getElementById('agency_name1');
            //@ViewChild("agency_name1") agencyNameElement: ElementRef;
            agencyNameElement.value =
              'Farmers Insurance - ' +
              (firstNameElement as HTMLInputElement).value +
              ' ' +
              (lastNameElement as HTMLInputElement).value;
          }
        );
      }
      if (field.fieldInfo.fieldName === 'last_name1') {
        this.unlistenerLastName = this.renderer2.listen(
          lastNameElement,
          'focusout',
          event => {
            agencyNameElement = document.getElementById('agency_name1');
            //@ViewChild("agency_name1") agencyNameElement: ElementRef;
            agencyNameElement.value =
              'Farmers Insurance - ' +
              (firstNameElement as HTMLInputElement).value +
              ' ' +
              (lastNameElement as HTMLInputElement).value;
          }
        );
      }
    });
  }
  setStatesEventHandler(agencyRequestField, statesElement) {
    let statesArray = [
      {
        State: 'AL',
        LicenseType: 'Nonresident License',
        LicenseNumber: '295045',
        RenewalDate: '12/31/2022'
      },
      {
        State: 'AK',
        LicenseType: 'Nonresident License',
        LicenseNumber: '70904',
        RenewalDate: '5/8/2022'
      },
      {
        State: 'AZ',
        LicenseType: 'Nonresident License',
        LicenseNumber: '1800005856',
        RenewalDate: '11/30/2023'
      },
      {
        State: 'AR',
        LicenseType: 'Nonresident License',
        LicenseNumber: '100106433',
        RenewalDate: '9/30/2023'
      },
      {
        State: 'CA',
        LicenseType: 'Nonresident License',
        LicenseNumber: '0G13555',
        RenewalDate: '5/31/2022'
      },
      {
        State: 'CO',
        LicenseType: 'Nonresident License',
        LicenseNumber: '303951',
        RenewalDate: '12/31/2099'
      },
      {
        State: 'CT',
        LicenseType: 'Nonresident License',
        LicenseNumber: '002296342',
        RenewalDate: '1/31/2022'
      },
      {
        State: 'DE',
        LicenseType: 'Nonresident License',
        LicenseNumber: '1068255',
        RenewalDate: '2/28/2023'
      },
      {
        State: 'DC',
        LicenseType: 'Nonresident License',
        LicenseNumber: '2854740',
        RenewalDate: '5/31/2022'
      },
      {
        State: 'FL',
        LicenseType: 'Nonresident License',
        LicenseNumber: 'L052845',
        RenewalDate: '12/31/2099'
      },
      {
        State: 'GA',
        LicenseType: 'Nonresident License',
        LicenseNumber: '120316',
        RenewalDate: '12/31/2022'
      },
      {
        State: 'HI',
        LicenseType: 'Nonresident License',
        LicenseNumber: '357767',
        RenewalDate: '4/16/2022'
      },
      {
        State: 'ID',
        LicenseType: 'Nonresident License',
        LicenseNumber: '277254',
        RenewalDate: '3/1/2022'
      },
      {
        State: 'IL',
        LicenseType: 'Nonresident License',
        LicenseNumber: '100305207',
        RenewalDate: '5/31/2022'
      },
      {
        State: 'IN',
        LicenseType: 'Nonresident License',
        LicenseNumber: '569736',
        RenewalDate: '12/31/2099'
      },
      {
        State: 'IA',
        LicenseType: 'Nonresident License',
        LicenseNumber: '1002016401',
        RenewalDate: '10/31/2024'
      },
      {
        State: 'KS',
        LicenseType: 'Nonresident License',
        LicenseNumber: '382336672-0',
        RenewalDate: '1/29/2022'
      },
      {
        State: 'KY',
        LicenseType: 'Nonresident License',
        LicenseNumber: 'DOI-658511',
        RenewalDate: '3/31/2023'
      },
      {
        State: 'LA',
        LicenseType: 'Nonresident License',
        LicenseNumber: '447162',
        RenewalDate: '3/31/2022'
      },
      {
        State: 'MA',
        LicenseType: 'Nonresident License',
        LicenseNumber: '1852703',
        RenewalDate: '5/20/2023'
      },
      {
        State: 'MD',
        LicenseType: 'Nonresident License',
        LicenseNumber: '99977769',
        RenewalDate: '6/27/2023'
      },
      {
        State: 'ME',
        LicenseType: 'Nonresident License',
        LicenseNumber: 'AGN147376',
        RenewalDate: '4/1/2023'
      },
      {
        State: 'MI',
        LicenseType: 'Resident License',
        LicenseNumber: '0007441',
        RenewalDate: '12/31/2099'
      },
      {
        State: 'MN',
        LicenseType: 'Nonresident License',
        LicenseNumber: '40078468',
        RenewalDate: '10/31/2023'
      },
      {
        State: 'MN',
        LicenseType: 'Nonresident License',
        LicenseNumber: '40078468',
        RenewalDate: '10/31/2023'
      },
      {
        State: 'MN',
        LicenseType: 'Nonresident License',
        LicenseNumber: '40078468',
        RenewalDate: '10/31/2023'
      },
      {
        State: 'MN',
        LicenseType: 'Nonresident License',
        LicenseNumber: '40078468',
        RenewalDate: '10/31/2023'
      },
      {
        State: 'MO',
        LicenseType: 'Nonresident License',
        LicenseNumber: '8024343',
        RenewalDate: '4/8/2022'
      },
      {
        State: 'MS',
        LicenseType: 'Nonresident License',
        LicenseNumber: '15008480',
        RenewalDate: '5/31/2022'
      },
      {
        State: 'MT',
        LicenseType: 'Nonresident License',
        LicenseNumber: '696970',
        RenewalDate: '12/31/2099'
      },
      {
        State: 'NC',
        LicenseType: 'Nonresident License',
        LicenseNumber: '1000008605',
        RenewalDate: '3/31/2022'
      },
      {
        State: 'ND',
        LicenseType: 'Nonresident License',
        LicenseNumber: '20291280',
        RenewalDate: '12/31/2099'
      },
      {
        State: 'NE',
        LicenseType: 'Nonresident License',
        LicenseNumber: '100187729',
        RenewalDate: '4/30/2022'
      },
      {
        State: 'NH',
        LicenseType: 'Nonresident License',
        LicenseNumber: '376447',
        RenewalDate: '5/31/2023'
      },
      {
        State: 'NJ',
        LicenseType: 'Nonresident License',
        LicenseNumber: '1142035',
        RenewalDate: '5/31/2023'
      },
      {
        State: 'NM',
        LicenseType: 'Nonresident License',
        LicenseNumber: '1800006755',
        RenewalDate: '2/28/2022'
      },
      {
        State: 'NV',
        LicenseType: 'Nonresident License',
        LicenseNumber: '4533',
        RenewalDate: '12/1/2023'
      },
      {
        State: 'NY',
        LicenseType: 'Nonresident License',
        LicenseNumber: 'BR-1075403',
        RenewalDate: '6/30/2023'
      },
      {
        State: 'OH',
        LicenseType: 'Nonresident License',
        LicenseNumber: '37541',
        RenewalDate: '9/30/2023'
      },
      {
        State: 'OK',
        LicenseType: 'Nonresident License',
        LicenseNumber: '10003532',
        RenewalDate: '1/31/2022'
      },
      {
        State: 'OR',
        LicenseType: 'Nonresident License',
        LicenseNumber: '100161597',
        RenewalDate: '11/30/2022'
      },
      {
        State: 'PA',
        LicenseType: 'Nonresident License',
        LicenseNumber: '52521',
        RenewalDate: '6/21/2023'
      },
      {
        State: 'SC',
        LicenseType: 'Nonresident License',
        LicenseNumber: '1902045920',
        RenewalDate: '1/31/2022'
      },
      {
        State: 'SD',
        LicenseType: 'Nonresident License',
        LicenseNumber: '10004154',
        RenewalDate: '7/1/2022'
      },
      {
        State: 'TN',
        LicenseType: 'Nonresident License',
        LicenseNumber: '4880',
        RenewalDate: '3/1/2023'
      },
      {
        State: 'TX',
        LicenseType: 'Nonresident License',
        LicenseNumber: '1495012',
        RenewalDate: '3/25/2022'
      },
      {
        State: 'UT',
        LicenseType: 'Nonresident License',
        LicenseNumber: '284324',
        RenewalDate: '4/30/2022'
      },
      {
        State: 'VA',
        LicenseType: 'Nonresident License',
        LicenseNumber: '106204',
        RenewalDate: '5/1/2023'
      },
      {
        State: 'VT',
        LicenseType: 'Nonresident License',
        LicenseNumber: '546575',
        RenewalDate: '3/31/2023'
      },
      {
        State: 'WA',
        LicenseType: 'Nonresident License',
        LicenseNumber: '159550',
        RenewalDate: '11/8/2023'
      },
      {
        State: 'WI',
        LicenseType: 'Nonresident License',
        LicenseNumber: '100193136',
        RenewalDate: '2/15/2022'
      },
      {
        State: 'WV',
        LicenseType: 'Nonresident License',
        LicenseNumber: '100108895',
        RenewalDate: '6/30/2022'
      },
      {
        State: 'WY',
        LicenseType: 'Nonresident License',
        LicenseNumber: '172631',
        RenewalDate: '2/28/2022'
      }
    ];
    statesElement = document.getElementById('state1');
    agencyRequestField.forEach(field => {
      if (field.fieldInfo.fieldName === 'state1') {
        this.unlistenerStates = this.renderer2.listen(
          statesElement,
          'click',
          event => {
            let state1 = document.getElementById('state1');
            let element = state1.querySelector('.ng-value-label');
            if (element != null) {
              let htmlElement = element as HTMLElement;
              var state = htmlElement.innerText;
              let selection = field.config.selectConfig.options.find(
                option => option.value === state
              );
              var entry = statesArray.find(
                item => item.State === selection.key
              );
              if (entry != undefined) {
                (document.getElementById('state') as HTMLInputElement).value =
                  entry.State;
                (document.getElementById(
                  'ParentLicenseType'
                ) as HTMLInputElement).value = entry.LicenseType;
                (document.getElementById(
                  'LicenseNumber'
                ) as HTMLInputElement).value = entry.LicenseNumber;
                (document.getElementById(
                  'license_expiration_date'
                ) as HTMLInputElement).value = entry.RenewalDate;
              }
            }
            //var e = (document.getElementById("state1")) as HTMLSelectElement;
            //var sel = e.selectedOptions;
            //var opt = e.options[sel];
            //var value = (<HTMLOptionElement>opt).value;
            // let count = 0;
            // field.config.selectConfig.options.forEach(option => {
            //   if(statesArray.length > count && option.key === statesArray[count].State) {
            //     console.log("Got Here");
            //   }
            //   count++;
            // });
          }
        );
      }
    });
  }
  setValidationforForm(
    siteCoreData,
    //phoneRequestField,
    //emailRequestField,
    agencyRequestField
    //agencyRequestProduct,
    //premiumProduct
  ) {
    let requiredValidation;
    let validationMessage;
    agencyRequestField.forEach((element: InputConfig) => {
      let userFieldName = siteCoreData.forms[0].fields.filter(
        x => x.fieldInfo.fieldName + '1' === element.fieldInfo.fieldName
      );
      if (userFieldName.length) {
        element.fieldInfo.label = userFieldName[0].fieldInfo.label;
      }
      if (element.fieldInfo.validations) {
        requiredValidation = element.fieldInfo.validations.filter(
          x => x.key === 'required'
        );
        let userRequestField = siteCoreData.forms[0].fields.filter(
          x => x.fieldInfo.label === element.fieldInfo.label
        );
        if (userRequestField) {
          validationMessage = userRequestField[0].fieldInfo.validations.filter(
            x => x.key === 'Required'
          );

          requiredValidation[0].value = userRequestField[0].fieldInfo.label; //+
          //' ' +
          //validationMessage[0].value;
        }
      }
    });
    // emailRequestField.forEach((element: InputConfig) => {
    //   let userFieldName = siteCoreData.forms[0].fields.filter(
    //     x => x.fieldInfo.fieldName + '1' === element.fieldInfo.fieldName
    //   );
    //   if (userFieldName) {
    //     element.fieldInfo.label = userFieldName[0].fieldInfo.label;
    //   }
    //   if (element.fieldInfo.validations) {
    //     requiredValidation = element.fieldInfo.validations.filter(
    //       x => x.key === 'required'
    //     );
    //     let emailField = siteCoreData.forms[0].fields.filter(
    //       x => x.fieldInfo.label === element.fieldInfo.label
    //     );
    //     if (emailField) {
    //       validationMessage = emailField[0].fieldInfo.validations.filter(
    //         x => x.key === 'Required'
    //       );
    //       requiredValidation[0].value =
    //         emailField[0].fieldInfo.label + ' ' + validationMessage[0].value;
    //     }
    //   }
    // });
    // phoneRequestField.forEach((element: InputConfig) => {
    //   let userFieldName = siteCoreData.forms[0].fields.filter(
    //     x => x.fieldInfo.fieldName + '1' === element.fieldInfo.fieldName
    //   );
    //   if (userFieldName) {
    //     element.fieldInfo.label = userFieldName[0].fieldInfo.label;
    //   }
    //   if (element.fieldInfo.validations) {
    //     requiredValidation = element.fieldInfo.validations.filter(
    //       x => x.key === 'required'
    //     );
    //     let phoneField = siteCoreData.forms[0].fields.filter(
    //       x => x.fieldInfo.label === element.fieldInfo.label
    //     );
    //     if (phoneField) {
    //       validationMessage = phoneField[0].fieldInfo.validations.filter(
    //         x => x.key === 'Required'
    //       );
    //       requiredValidation[0].value =
    //         phoneField[0].fieldInfo.label + ' ' + validationMessage[0].value;
    //     }
    //   }
    // });
    // agencyRequestProduct.forEach((element: InputConfig) => {
    //   let userFieldName = siteCoreData.forms[0].fields.filter(
    //     x => x.fieldInfo.fieldName === element.fieldInfo.fieldName
    //   );
    //   if (userFieldName) {
    //     element.fieldInfo.label = userFieldName[0].fieldInfo.label;
    //     this.checkboxFlag = true;
    //   }
    // });
  }

  setEntity() {
    this.agencyRequestField = this.quoteInformationConfig.quoteFieldConfig;
    //this.phoneRequestField = this.phoneRequestForm.phoneRequestFieldConfig;
    //this.emailRequestField = this.emailRequestForm.emailRequestFieldConfig;
    //this.agencyRequestProduct = this.agencyRequestProducts.agencyRequestProductsFieldConfig;
    //this.premiumProduct = this.premiumProducts.premiumFieldConfig;
    //this.companyRequestField = this.companyRequest.companyRequestFieldConfig;
  }
  setFormControl(
    agencyRequestField
    //phoneRequestField,
    //emailRequestField,
    //agencyRequestProduct,
    //premiumProduct,
    //companyRequestField
  ) {
    agencyRequestField.forEach((element: InputConfig) => {
      let validators;

      if (element.config && element.config.validation) {
        validators = element.config.validation;
      } else {
        validators = null;
      }
      if (element.fieldInfo.fieldName !== 'state1') {
        this.agencyFormControl[element.fieldInfo.fieldName] = [
          '',
          Validators.compose(validators)
        ];
      } else {
        this.agencyFormControl[element.fieldInfo.fieldName] = [
          null,
          Validators.compose(validators)
        ];
      }
    });

    // phoneRequestField.forEach((element: InputConfig) => {
    //   let validators;
    //   if (element.config && element.config.validation) {
    //     validators = element.config.validation;
    //   } else {
    //     validators = null;
    //   }
    //   this.agencyFormControl[element.fieldInfo.fieldName] = [
    //     '',
    //     Validators.compose(element.config.validation)
    //   ];
    // });
    // emailRequestField.forEach((element: InputConfig) => {
    //   let validators;
    //   if (element.config && element.config.validation) {
    //     validators = element.config.validation;
    //   } else {
    //     validators = null;
    //   }
    //   this.agencyFormControl[element.fieldInfo.fieldName] = [
    //     '',
    //     Validators.compose([
    //       Validators.required,
    //       Validators.pattern(
    //         '[_a-z0-9]+(.[_a-z0-9]+)*@[a-z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,4})$'
    //       )
    //     ])
    //   ];
    // });

    // agencyRequestProduct.forEach((element: InputConfig) => {
    //   let validators;
    //   if (element.config && element.config.validation) {
    //     validators = element.config.validation;
    //   } else {
    //     validators = null;
    //   }
    //   this.agencyFormControl[element.fieldInfo.fieldName] = [
    //     '',
    //     Validators.compose(validators)
    //   ];
    // });
    // premiumProduct.forEach((element: InputConfig) => {
    //   let validators;
    //   if (element.config && element.config.validation) {
    //     validators = element.config.validation;
    //   } else {
    //     validators = null;
    //   }
    //   this.agencyFormControl[element.fieldInfo.fieldName] = [
    //     '',
    //     Validators.compose(validators)
    //   ];
    // });
    // companyRequestField.forEach((element: InputConfig) => {
    //   let validators;
    //   if (element.config && element.config.validation) {
    //     validators = element.config.validation;
    //   } else {
    //     validators = null;
    //   }
    //   this.agencyFormControl[element.fieldInfo.fieldName] = [
    //     '',
    //     Validators.compose(validators)
    //   ];
    // });

    this.frmGroup = this.formBuilder.group(this.agencyFormControl);
  }
  get f() {
    return this.frmGroup.controls;
  }
  saveAgencyRequest(event, formGroup: NgForm) {
    this.loaderService.hide();
    this.validationService.setFormSubmission(true);
    this.hasFormBeenSubmitted = true;
    //const radioValue = formGroup.form.controls['00N6g00000TXa9h'].value;
    if (this.frmGroup.valid) {
      //this.radioSelected = true;
      // this.copyInputValue(this.cn.upn);
      this.copyInputValue(this.cn.aor);
      // this.copyInputValue(this.cn.kraft_lake_entity_type);
      // this.copyInputValue(this.cn.agency_status);
      this.copyInputValue(this.cn.first_name);
      this.copyInputValue(this.cn.last_name);
      this.copyInputValue(this.cn.agency_name);
      // this.copyInputValue(this.cn.tax_id);
      // this.copyInputValue(this.cn.tax_id_type);
      // this.copyInputValue(this.cn.sub_company);
      // this.copyInputValue(this.cn.kraft_lake_agency_type);
      // this.copyInputValue(this.cn.commission_option);
      // this.copyInputValue(this.cn.payment_plan);
      // this.copyInputValue(this.cn.commission_plan);
      // this.copyInputValue(this.cn.commission_amount);
      // this.copyInputValue(this.cn.kraft_lake_eo_carrier);
      // this.copyInputValue(this.cn.eo_limits);
      // this.copyInputValue(this.cn.eo_policy_number);
      // this.copyInputValue(this.cn.eo_expiration_date);
      // this.copyInputValue(this.cn.address_type);
      this.copyInputValue(this.cn.office_address);
      this.copyInputValue(this.cn.city);
      //this.copyInputValue(this.cn.state);
      this.copyInputValue(this.cn.zip);
      // this.copyInputValue(this.cn.office_country);
      // this.copyInputValue(this.cn.phone_type);
      this.copyInputValue(this.cn.phone);
      // this.copyInputValue(this.cn.email_type);
      this.copyInputValue(this.cn.email);
      // this.copyInputValue(this.cn.licensee_name);
      //this.copyInputValue(this.cn.ParentLicenseType);
      //this.copyInputValue(this.cn.LicenseNumber);
      //this.copyInputValue(this.cn.license_expiration_date);
      // const checkboxes = [
      //   '00N6g00000TXa0v',
      //   '00N6g00000TXa0v',
      //   '00N6g00000TXa0v',
      //   '00N6g00000TXa0v',
      //   '00N6g00000TXa0v',
      //   '00N6g00000TXa0v'
      // ];

      // this.createCheckBox(checkboxes);
      // (document.getElementById(
      //   'OfficeState'
      // ) as HTMLInputElement).value = (document
      //   .getElementById('OfficeState1')
      //   .querySelector('.ng-value-label') as HTMLElement).innerText;
      // let officeState = document.getElementById('state');
      // let htmlInputElement = officeState as HTMLInputElement;
      // let officeState1 = document.getElementById('state1');
      // let element = officeState1.querySelector('.ng-value-label');
      // let htmlElement = element as HTMLElement;
      // htmlInputElement.value = htmlElement.innerText;
      // (document.getElementById(
      //   'ParentLicenseType'
      // ) as HTMLInputElement).value = (document
      //   .getElementById('ParentLicenseType1')
      //   .querySelector('.ng-value-label') as HTMLElement).innerText;
      // (document.getElementById(
      //   'LicenseNumber'
      // ) as HTMLInputElement).value = (document
      //   .getElementById('LicenseNumber1')
      //   .querySelector('.ng-value-label') as HTMLElement).innerText;
      this.loaderService.hide();
      event.target.submit();
    } else {
      //if (radioValue === '') {
      //this.radioSelected = false;
      //}
    }
  }
  copyInputValue(id) {
    const id_form = id + '1';
    if (document.getElementById(id) && document.getElementById(id_form)) {
      // if (id == 'agency_name') {
      //   (document.getElementById(id) as HTMLFormElement).value =
      //     'Farmers Insurance - ' +
      //     (document.getElementById(id_form) as HTMLFormElement).value;
      // } else {
      (document.getElementById(
        id
      ) as HTMLFormElement).value = (document.getElementById(
        id_form
      ) as HTMLFormElement).value;
    }
    //}
  }

  createCheckBox(names: string[]) {
    names.forEach((name, i) => {
      const index = i == 0 ? '' : i;
      const checkbox = document.createElement('input');
      checkbox.setAttribute('type', 'checkbox');
      checkbox.setAttribute('type', 'hidden');

      if ($('#agency-request') && $('#' + name + index)) {
        const element = $('#' + name + index);
        const isChecked = element.prop('checked');
        const value = element.attr('title');

        checkbox.setAttribute('name', name);
        checkbox.setAttribute('value', value);

        if (isChecked) {
          $('#agency-request').prepend(checkbox);
        }
      }
    });
  }
}
